import { Button, Checkbox, Flex, Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import PlusIcon from 'components/atoms/icons/plus.svg?react';
import { ModuleType } from 'infrastructure/enums';

import styles from './styles.module.scss';

import type { ITabsControlProps } from './types';

export const TabsControl = ({
  activeModule,
  onModuleChange,
  showExpired,
  onShowExpiredChange,
  onAddClick,
  isReadOnly,
  isLoading,
  hideAddButton,
  availableModules,
}: ITabsControlProps) => {
  const { t } = useTranslation();

  const moduleOptions = availableModules.length
    ? availableModules.map((module) => ({
        label:
          module === ModuleType.RPM
            ? t('tabs.rpm', 'RPM')
            : t('tabs.ccm', 'CCM'),
        value: module,
      }))
    : [
        {
          label: t('tabs.rpm', 'RPM'),
          value: ModuleType.RPM,
        },
        {
          label: t('tabs.ccm', 'CCM'),
          value: ModuleType.CCM,
        },
      ];

  return (
    <Flex justify="space-between" align="center">
      <Flex gap={12} align="center">
        <Segmented
          options={moduleOptions}
          value={activeModule}
          onChange={(value) => onModuleChange(value as ModuleType)}
          className={styles.segmented}
        />
        <Checkbox
          className={styles.checkbox}
          checked={showExpired}
          onChange={(e) => onShowExpiredChange(e.target.checked)}
        >
          {t('labels.showExpiredEntries', 'Show Expired Entries')}
        </Checkbox>
      </Flex>

      <Flex align="center">
        {!hideAddButton && !isReadOnly && (
          <Button
            type="primary"
            icon={<PlusIcon />}
            onClick={onAddClick}
            loading={isLoading}
            disabled={isReadOnly}
            className={styles.addButton}
          >
            {t('controls.add', 'Add')}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
